/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { ToastContainer } from "react-toastify";
import UserDTO from "../../data/dtos/UserDTO";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { AuthProvider } from "./auth";

// eslint-disable-next-line no-shadow
export enum RegisterStepsEnum {
  INITIAL,
  REGISTER_DEV,
  SELECT_PLAN,
  ACCEPT_TERM,
}
interface ILucralizeContext {
  registeredUser?: UserDTO | null;
  changeRegisteredUser: (user: UserDTO) => void;
  step: RegisterStepsEnum;
  changeStep: (step: RegisterStepsEnum) => void;
}

const LucralizeContext = createContext<ILucralizeContext | null>(null);

const LucralizeProvider: React.FC = ({ children }) => {
  const [registeredUser, setRegisteredUser] = useState<UserDTO | null>(null);
  const [step, setStep] = useState(RegisterStepsEnum.INITIAL);

  const changeRegisteredUser = useCallback(
    (currentRegisteredUser?: UserDTO | null) => {
      if (currentRegisteredUser) {
        setRegisteredUser(currentRegisteredUser);
      }
    },
    [registeredUser]
  );

  useEffect(() => {
    const localData = LocalStorageUtils.getItem("userRegister");
    const registeredUserLocal: UserDTO | null = localData
      ? JSON.parse(localData || "")
      : null;
   
    if (registeredUserLocal) {
      changeRegisteredUser(registeredUser);
    }
  }, []);

  const changeStep = useCallback(
    (currentStep: RegisterStepsEnum) => {
      setStep(currentStep);
    },
    [step]
  );

  return (
    <LucralizeContext.Provider
      value={{
        registeredUser,
        changeRegisteredUser,
        step,
        changeStep,
      }}>
      <AuthProvider>
        {children}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </AuthProvider>
    </LucralizeContext.Provider>
  );
};

function useLucralizeContext(): ILucralizeContext {
  const context = useContext(LucralizeContext);

  if (!context) {
    throw new Error(
      "'useLucralizeContext' must be used within a 'LucralizeProvider'"
    );
  }

  return context;
}

export { LucralizeProvider, useLucralizeContext };
